import {useSummary} from 'context/summary';
import {useBrandingTheme} from 'context/brandingTheme';
import {useSplashCoverStore} from 'components/SplashScreen/useSplashCoverStore';
import {useBookingFoundHandoffStore} from 'pages/SearchReservation/useBookingFoundHandoffStore';

function useIsSessionModalReady() {
  const {isSuccess: isSummaryLoaded = false} = useSummary();
  const {isTemplateInitialized} = useBrandingTheme();
  const isPageUncovered = useSplashCoverStore(state => state.cover === 'none');
  const isHandoffOver = useBookingFoundHandoffStore(state => !state.handoff);

  return isTemplateInitialized && isSummaryLoaded && isPageUncovered && isHandoffOver;
}

export {useIsSessionModalReady};
